import React from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { Link, Outlet, useLocation } from 'react-router-dom';
import './Cpanel.css';

function Cpanel() {
  const location = useLocation();
  
  // Determine active key based on current path
  const getActiveKey = () => {
    const path = location.pathname;
    if (path.includes('/cpanel/dashboard')) return '/cpanel/dashboard';
    if (path.includes('/cpanel/events')) return '/cpanel/events';
    if (path.includes('/cpanel/reservations')) return '/cpanel/reservations';
    if (path.includes('/cpanel/statistics')) return '/cpanel/statistics';
    if (path.includes('/cpanel/settings')) return '/cpanel/settings';
    return '/cpanel/dashboard'; // Default
  };

  return (
    <Container fluid className="cpanel-container py-5 mt-5">
      <Row>
        {/* Sidebar */}
        <Col md={3} lg={2} className="cpanel-sidebar">
          <div className="cpanel-sidebar-header mb-4">
            <h4>Panneau de contrôle</h4>
            <p className="text-muted">Gestion partenaire</p>
          </div>
          
          <Nav className="flex-column" activeKey={getActiveKey()}>
            <Nav.Link 
              as={Link} 
              to="/cpanel/dashboard" 
              className={`cpanel-sidebar-link ${getActiveKey() === '/cpanel/dashboard' ? 'active' : ''}`}
            >
              <i className="fas fa-tachometer-alt me-2"></i> Tableau de bord
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/cpanel/events" 
              className={`cpanel-sidebar-link ${getActiveKey() === '/cpanel/events' ? 'active' : ''}`}
            >
              <i className="fas fa-calendar-alt me-2"></i> Événements
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/cpanel/reservations" 
              className={`cpanel-sidebar-link ${getActiveKey() === '/cpanel/reservations' ? 'active' : ''}`}
            >
              <i className="fas fa-ticket-alt me-2"></i> Réservations
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/cpanel/statistics" 
              className={`cpanel-sidebar-link ${getActiveKey() === '/cpanel/statistics' ? 'active' : ''}`}
            >
              <i className="fas fa-chart-bar me-2"></i> Statistiques
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/cpanel/settings" 
              className={`cpanel-sidebar-link ${getActiveKey() === '/cpanel/settings' ? 'active' : ''}`}
            >
              <i className="fas fa-cog me-2"></i> Paramètres
            </Nav.Link>
          </Nav>
          
          <div className="cpanel-sidebar-footer mt-auto pt-4">
            <Nav.Link as={Link} to="/profile" className="cpanel-sidebar-link">
              <i className="fas fa-user-circle me-2"></i> Mon profil
            </Nav.Link>
            <Nav.Link as={Link} to="/" className="cpanel-sidebar-link">
              <i className="fas fa-home me-2"></i> Retour au site
            </Nav.Link>
          </div>
        </Col>
        
        {/* Content */}
        <Col md={9} lg={10} className="cpanel-content">
          <Outlet />
        </Col>
      </Row>
    </Container>
  );
}

export default Cpanel;